import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Clock, TrendingUp, ExternalLink } from "lucide-react";
import { VendorLogo } from "./VendorLogo";

export function VendorQuickAccess({ data, onOpenVendor, onOpenLink }) {
  if (!data) return null;
  return (
    <Card data-testid="vendor-quick-access">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Schnellzugriff</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-6 lg:grid-cols-2">
        <div>
          <p className="text-sm font-medium mb-3 flex items-center gap-2"><Clock className="w-4 h-4 text-muted-foreground" />Zuletzt geöffnet</p>
          {data.recent.length ? (
            <div className="flex flex-wrap gap-2">
              {data.recent.map((v) => (
                <Button key={v.id} variant="outline" className="h-auto py-2 gap-2" onClick={() => onOpenVendor(v.id)} data-testid={`quick-recent-${v.id}`}>
                  <VendorLogo vendor={v} size="w-7 h-7" text="text-xs" />
                  {v.name}
                </Button>
              ))}
            </div>
          ) : (
            <p className="text-sm text-muted-foreground" data-testid="quick-recent-empty">Noch keine Hersteller geöffnet.</p>
          )}
        </div>
        <div>
          <p className="text-sm font-medium mb-3 flex items-center gap-2"><TrendingUp className="w-4 h-4 text-muted-foreground" />Häufig genutzte Links</p>
          {data.top_links.length ? (
            <div className="grid gap-2 sm:grid-cols-2">
              {data.top_links.map((l) => (
                <button
                  key={l.id}
                  onClick={() => onOpenLink(l.vendor_id, l)}
                  className="flex items-center gap-2 rounded-lg border border-border px-3 py-2 text-left hover:bg-muted/60 transition-colors"
                  data-testid={`quick-link-${l.id}`}
                >
                  <VendorLogo vendor={{ id: l.vendor_id, name: l.vendor_name, has_logo: l.has_logo }} size="w-7 h-7" text="text-xs" />
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-medium truncate">{l.title}</span>
                    <span className="block text-xs text-muted-foreground truncate">{l.vendor_name} · {l.click_count}× geöffnet</span>
                  </span>
                  <ExternalLink className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
                </button>
              ))}
            </div>
          ) : (
            <p className="text-sm text-muted-foreground" data-testid="quick-links-empty">Noch keine Links genutzt.</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
